import { ApcCtaApi } from '../types/api/apc-cta-api';
import { BaseRouteProps } from '../types/route-props';
import { buildURL, isV3 } from '../common';
import { Method, callAxios } from '../axios';
import { getBrandName } from '../locale';

const buildCtaUrl = ({ contextRoot, countryCode, languageCode }) => {
  if (isV3()) {
    const endPoint = '/products-cta';
    const queryParams = `?country-code=${countryCode}&language-code=${languageCode}&brand=${getBrandName()}`;
    const url = endPoint + queryParams;
    return url;
  }

  return buildURL({
    host: process.env.API_HOST,
    contextRoot,
    countryCode,
    languageCode,
    endpoint: '/product/api/commerce-api/cta',
  });
};

export const apcCtaApiFetchers = {
  getApcCtaFetcher: async ({ contextRoot, countryCode, languageCode }: BaseRouteProps) => {
    const GET_APC_CTA_URL = process.env.REACT_APP_DEV === 'mock'
      ? 'http://localhost:3100/get-apc-cta'
      : buildCtaUrl({ contextRoot, countryCode, languageCode });

    const response = await callAxios<{
      response: ApcCtaApi.ApcCtaResponse;
    }>({
      method: Method.GET,
      url: GET_APC_CTA_URL,
    });

    return response.data;
  },
};
